import script from "./videoModal.vue?vue&type=script&lang=js"
export * from "./videoModal.vue?vue&type=script&lang=js"

import "./videoModal.vue?vue&type=style&index=0&id=5a64715a&lang=scss"

const __exports__ = script;

export default __exports__